import { Form, Select } from 'antd';
import React, { memo } from 'react';
import useReceiptTypes from '../../../../queries/useReceiptTypes';

const ReceiptSelect = ({
  editingCounterparty,
  getFieldDecorator,
  getOptions,
}) => {
  const { data: receiptTypes, isFetching: receiptTypesLoading } =
    useReceiptTypes();
  return (
    <Form.Item label="Тип квитанции">
      {getFieldDecorator('receipt', {
        ...getOptions('Выберите тип квитанции'),
        initialValue: editingCounterparty?.receipt
          ? {
              key: editingCounterparty.receipt.id,
              label: editingCounterparty.receipt.name,
            }
          : undefined,
      })(
        <Select
          labelInValue
          loading={receiptTypesLoading}
          placeholder="Выберите тип квитанции"
        >
          {receiptTypes?.map((el) => (
            <Select.Option key={el.id}>{el.name}</Select.Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default memo(ReceiptSelect);
